import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const neutral100 = constants.colors.ui.neutral[100];
const neutral700 = constants.colors.ui.neutral[700];

const { fontFamily, fontSize } = typographyStyles;

export const modalHeaderCss = {
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  borderBottom: `1px solid ${neutral100}`,
};

export const headerTitleCss: CSSObject = {
  ...fontFamily.noto,
  ...fontSize.heading3,
  fontWeight: 700,
  color: neutral700,
};

export const closeButtonCss: CSSObject = {
  alignSelf: "center",
  color: neutral700,
  "& svg": {
    height: "27px",
  },
};
